import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EstimatedUnbillFigureEntity } from "domain/entity/EstimatedUnbillFigure/EstimatedUnbillFigureEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { EstimatedUnbillFigureRepository } from "./EstimatedUnbillFigureRepo";

export const EstimatedUnbillFigureRepoImpl = (): EstimatedUnbillFigureRepository => {

    const url = "/v1/estimatedUnbillFigure"

    const searchAllEstimatedUnbillFigureList = async (): Promise<EstimatedUnbillFigureEntity[]> => {
        const newUrl = url + "/searchAll";
        return axiosGetData(referenceAxiosInstance, `${newUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (row: EstimatedUnbillFigureEntity): Promise<ResponseEntity> => {
        const newUrl = url + "/save";
        return await axiosPostData(referenceAxiosInstance, `${newUrl}`, row);
    }

    return {
        onSave: onSave,
        searchAllEstimatedUnbillFigureList: searchAllEstimatedUnbillFigureList,
    }
}
